export const MODALS_ID = {
  CHANGE_PASSWORD_MODAL: "CHANGE_PASSWORD_MODAL",
  VIDEO_MODAL: "VIDEO_MODAL",
  TRAIN_THE_TRAINER_MODAL: "TRAIN_THE_TRAINER_MODAL"
};
